var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchAlt = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.679,
    height: 22.679,
    viewBox: "0 0 22.679 22.679",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search.2",
    d: "M21.469,20.333l-5.446-5.446a.5.5,0,0,0-.359-.148h-.435a8.694,8.694,0,1,0-.49.494v.431a.519.519,0,0,0,.148.359l5.446,5.446a.507.507,0,0,0,.718,0l.418-.418A.507.507,0,0,0,21.469,20.333ZM8.782,16.213a7.431,7.431,0,1,1,7.431-7.431A7.426,7.426,0,0,1,8.782,16.213Z",
    transform: "translate(0.5 0.5)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchAlt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search-alt.4ba7b2fe5c01dc46e394be22eaced4dc.svg";